import {
  BrandKit,
  ButtonHierarchy,
  ButtonOptionsOverride,
} from "@redotech/redo-model/brand-kit";
import * as classNames from "classnames";
import { memo } from "react";
import {
  RedoButton,
  RedoButtonHierarchy,
  RedoButtonProps,
} from "./arbiter-components/buttons/redo-button";
import * as css from "./brand-kit-button.module.css";
import { getButtonStyles } from "./brand-kit-utils";

const hierarchyLiteralToEnum: Record<string, RedoButtonHierarchy> = {
  primary: RedoButtonHierarchy.PRIMARY,
  secondary: RedoButtonHierarchy.SECONDARY,
  tertiary: RedoButtonHierarchy.TERTIARY,
} as const;

export const BrandKitButton = memo(function BrandKitButton({
  brandKit,
  override,
  hierarchy,
  ...props
}: Omit<RedoButtonProps, "hierarchy" | "style"> & {
  brandKit: BrandKit;
  override?: ButtonOptionsOverride;
  hierarchy: ButtonHierarchy;
}) {
  const style = getButtonStyles({
    brandKit,
    hierarchy,
    override: override?.[hierarchy],
    fullWidth: true,
  });

  return (
    <RedoButton
      className={classNames(
        props.className,
        css.brandKitButton,
        css[hierarchy],
      )}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      hierarchy={hierarchyLiteralToEnum[hierarchy]}
      {...props}
    />
  );
});
